import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { SvgIcon } from '../svg-icon'

const LEVELS_MAPPING = {
    0: 'M10,3V19a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V3A1,1,0,0,1,1,2H3V1A1,1,0,0,1,4,0H6A1,1,0,0,1,7,1V2H9A1,1,0,0,1,10,3ZM6,3V1H4V3H1V19H9V3Z',
    20: 'M10,3V19a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V3A1,1,0,0,1,1,2H3V1A1,1,0,0,1,4,0H6A1,1,0,0,1,7,1V2H9A1,1,0,0,1,10,3ZM6,3V1H4V3H1V19H9V3ZM8,16H2v2H8Z',
    40: 'M10,3V19a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V3A1,1,0,0,1,1,2H3V1A1,1,0,0,1,4,0H6A1,1,0,0,1,7,1V2H9A1,1,0,0,1,10,3ZM6,3V1H4V3H1V19H9V3ZM8,16H2v2H8Zm0-3H2v2H8Z',
    60: 'M10,3V19a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V3A1,1,0,0,1,1,2H3V1A1,1,0,0,1,4,0H6A1,1,0,0,1,7,1V2H9A1,1,0,0,1,10,3ZM6,3V1H4V3H1V19H9V3ZM8,16H2v2H8Zm0-3H2v2H8Zm0-3H2v2H8Z',
    80: 'M10,3V19a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V3A1,1,0,0,1,1,2H3V1A1,1,0,0,1,4,0H6A1,1,0,0,1,7,1V2H9A1,1,0,0,1,10,3ZM6,3V1H4V3H1V19H9V3ZM8,16H2v2H8Zm0-3H2v2H8Zm0-3H2v2H8ZM8,7H2V9H8Z',
    100: 'M10,3V19a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V3A1,1,0,0,1,1,2H3V1A1,1,0,0,1,4,0H6A1,1,0,0,1,7,1V2H9A1,1,0,0,1,10,3ZM6,3V1H4V3H1V19H9V3ZM8,16H2v2H8Zm0-3H2v2H8Zm0-3H2v2H8ZM8,7H2V9H8ZM8,4H2V6H8Z'
}

const propTypes = {
    level: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    mainClassName: PropTypes.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    level: 0,
    viewBoxSize: 24
}

/**
 * Stateless function representing a battery level icon
 *
 * @function
 * @param {Object} [props] Component properties
 * @param {number} [props.level] - Value of the battery level from range [0 - 100] percent
 * @param {string} [props.mainClassName] - Class name for the main svg
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <BatteryLevelIcon level={20} />
 */

const BatteryLevelIcon = function (props) {
    const { level, mainClassName } = props

    const getBatteryLevelIconValue = batteryLevel => {
        const normalizedBatteryLevel = Math.ceil(batteryLevel / 10) * 10
        return Math.floor(normalizedBatteryLevel / 20) * 20
    }

    let verifiedLevel = Number.isInteger(level) ? level : 0
    if (verifiedLevel < 0) {
        verifiedLevel = 0
    } else if (verifiedLevel > 100) {
        verifiedLevel = 100
    }

    return (
        <SvgIcon {...props} className={cx(mainClassName, 't3sel-battery-level-icon')}>
            <path d={LEVELS_MAPPING[getBatteryLevelIconValue(verifiedLevel)]} />
        </SvgIcon>
    )
}

BatteryLevelIcon.propTypes = propTypes
BatteryLevelIcon.defaultProps = defaultProps

export { BatteryLevelIcon }
